import { i18n } from "@lingui/core";
import { AuthActionEnum } from "@mobsuccess-devops/react-shared/auth";
import { axiosPost } from "@mobsuccess-devops/react-shared/fetch";
import { useToasters } from "@mobsuccess-devops/react-ui/Toaster/use-toasters";
import { useMutation } from "@tanstack/react-query";

import { AxiosError } from "axios";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useForgotPassword() {
  const { toast } = useToasters();

  return useMutation({
    mutationKey: [AuthActionEnum.ForgotPassword],
    async mutationFn(options: { email: string }) {
      await axiosPost({
        entity: "auth",
        verb: "sendresetpassword",
        token: null,
        params: {
          email: options.email,
        },
      });
    },
    onError(error) {
      if (error instanceof AxiosError) {
        if (error.response?.status === 422) {
          const data = error.response.data;
          let email = "contact@mobsuccess.com";
          if ("error" in data && "message" in data.error) {
            email = String(data.error.message).replace(/^.+NPAI : (.+)$/, "$1");
          }
          toast.error({
            title: i18n._("src.public.auth.forgot-password-error.title"),
            description: i18n._(
              "src.public.auth.forgot-password-error.description-npai",
            ),
            actions: [
              {
                id: "contact",
                label: i18n._(
                  "src.public.auth.forgot-password-error.button-text",
                ),
                onClick: () => window.open(`mailto:${email}`, "_blank"),
                variant: "outlined",
                palette: "danger",
              },
            ],
          });
        }
        return;
      }
      toast.error({
        title: i18n._("src.public.auth.forgot-password-error.title"),
        description: i18n._(
          "src.public.auth.forgot-password-error.description",
        ),
      });
    },
  });
}
